function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import MaterialDialogContent from '@material-ui/core/DialogContent';
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
var styles = {
  root: {
    padding: '24px 24px 0'
  }
  /**
   * Overrides the Material DialogContent component with some custom styles.
   */

};

var DialogContent = function DialogContent(_ref) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(MaterialDialogContent, other, children);
};

export default withStyles(styles)(DialogContent);